import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["ClientGlobalReach"] */ "/vercel/path0/src/components/sections/client-global-reach.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/sections/stats.tsx");
